import React, { useState } from 'react';

import { Stack, Flex, useMantineTheme } from '@mantine/core';
import { useMediaQuery, useDebouncedValue, useDisclosure } from '@mantine/hooks';
import ShoppingCart from 'components/ShoppingCart';
import { useAuth } from 'context/auth-context';
import { ProductRetrieve } from 'types';

import DrawerRetailForm from './components/DrawerRetailForm';
import RetailPageHeader from './components/RetailPageHeader';
import RetailTable from './components/RetailTable';

const Retail = (): JSX.Element => {
  const theme = useMantineTheme();
  const { hasPerm } = useAuth();

  const isDesktop = useMediaQuery(`(min-width: ${theme.breakpoints.lg}`, false);

  const [search, setSearch] = useState<string>('');
  const [orderByFavorites, setOrderByFavorites] = useState<boolean>(true);
  const [debouncedSearch] = useDebouncedValue<string>(search, 250);

  const [isRetailDrawerOpened, { toggle: handleRetailDrawerToggle }] = useDisclosure(false);
  const [retailId, setRetailId] = useState<string>('');

  const [cartItems, setCartItems] = useState<ProductRetrieve[]>([]);
  const [isShoppingCartOpened, { toggle: handleShoppingCartToggle }] = useDisclosure(false);

  const productMutatePerm = hasPerm('ProductMutate');

  const invoiceCreatePerm = hasPerm('InvoiceCreate');

  const handleCloseRetailDrawer = (): void => {
    setRetailId('');
    handleRetailDrawerToggle();
  };

  return (
    <>
      <Flex sx={{ width: '100%', height: '100%' }}>
        <Stack
          spacing={0}
          sx={{
            width: isDesktop ? '50%' : '100%',
            height: '100%',
            display: !isShoppingCartOpened || isDesktop ? undefined : 'none',
          }}
        >
          <RetailPageHeader
            isDesktop={isDesktop}
            count={cartItems.length}
            search={search}
            setSearch={setSearch}
            orderByFavorites={orderByFavorites}
            setOrderByFavorites={setOrderByFavorites}
            openDrawer={handleRetailDrawerToggle}
            openCart={handleShoppingCartToggle}
            permission={productMutatePerm}
          />
          <RetailTable
            search={debouncedSearch}
            orderByFavorites={orderByFavorites}
            openDrawer={handleRetailDrawerToggle}
            setRetailId={setRetailId}
            cartItems={cartItems}
            setCartItems={setCartItems}
            productMutatePerm={productMutatePerm}
            invoiceCreatePerm={invoiceCreatePerm}
          />
        </Stack>
        <ShoppingCart
          isDesktop={isDesktop}
          visible={isShoppingCartOpened || isDesktop}
          cartItems={cartItems}
          setCartItems={setCartItems}
          closeCart={handleShoppingCartToggle}
          permission={invoiceCreatePerm}
          productTypeModule='retail'
        />
      </Flex>
      <DrawerRetailForm
        opened={isRetailDrawerOpened}
        closeHandler={handleCloseRetailDrawer}
        productId={retailId}
        permission={productMutatePerm}
        handleResetCart={() => setCartItems([])}
      />
    </>
  );
};

export default Retail;
